export default __webpack_public_path__ + "static/media/event-bg2.01c4c8d1.png";